import React from "react";
import {Devices} from "../../../components/ResponsiveView/consts.js";
import {DeliveryProviderDeliveries} from "./DeliveryProviderDeliveries.jsx";
import {ResponsiveView} from "../../../components";
import {DeliveryProviderDeliveriesProvider} from "./DeliveryProviderDeliveriesContext.jsx";
import {TableDateSearchProvider} from "../../../admin/Context/TableDateSearchContext.jsx";
import {DeliveryProviderDeliveriesMobile} from "./DeliveryProviderDeliveries.mobile.jsx";

export const DeliveryProviderDeliveriesWrapper = ({history}) => {
    return (
        <TableDateSearchProvider localStorageKey="deliveryProvidersSearchDate">
            <DeliveryProviderDeliveriesProvider>
                <ResponsiveView devices={[Devices.desktop]}>
                    <DeliveryProviderDeliveries history={history} />
                </ResponsiveView>

                <ResponsiveView devices={[Devices.mobile]}>
                    <DeliveryProviderDeliveriesMobile history={history} />
                </ResponsiveView>
            </DeliveryProviderDeliveriesProvider>
        </TableDateSearchProvider>
    );
};
